import { useTranslation } from 'react-i18next'

import { getTranslatedOptions } from '../../../../utils/translation'
import { APPOINTMENT_REMINDER_OPTIONS } from '../../../Appointment'
import { Divider } from '../../../Divider'
import { SettingsField, SettingsSection } from '../../../Settings'
import {
  CALENDAR_SETTINGS_FIELD_NAME_DEFAULT_REMINDER,
  QA_NAME_CALENDAR_SETTINGS_APPOINTMENTS,
} from '../../CalendarSettings.constants'
import { CalendarSettingsSelectField } from '../CalendarSettingsSelectField'
import { SenderMailboxField } from '../SenderMailboxField'

import * as styles from './AppointmentsSection.module.css'

function AppointmentsSection({ isLoading, settings }) {
  const { t } = useTranslation()

  return (
    <>
      <Divider />
      <SettingsSection
        descriptionKey='CalendarSettings.AppointmentsSectionDescriptionKey'
        qaName={QA_NAME_CALENDAR_SETTINGS_APPOINTMENTS}
        titleKey='CalendarSettings.AppointmentsSectionTitleKey'
      >
        <div className={styles.body}>
          {isLoading ? (
            <>
              <SettingsField isLoading className={styles.fieldSkeleton} />
              <SettingsField isLoading className={styles.fieldSkeleton} />
            </>
          ) : (
            <>
              <CalendarSettingsSelectField
                labelKey='CalendarSettings.DefaultReminderKey'
                name={CALENDAR_SETTINGS_FIELD_NAME_DEFAULT_REMINDER}
                options={getTranslatedOptions({
                  options: APPOINTMENT_REMINDER_OPTIONS,
                  t,
                })}
              />
              <SenderMailboxField
                deadReference={settings.sender_dead_reference}
                options={settings.sender_mail_account_options}
              />
            </>
          )}
        </div>
      </SettingsSection>
    </>
  )
}

export default AppointmentsSection
